
import { useEffect, useState } from "react";
import axios from "../utils/axiosInstance";
import TextView from "../components/textview/TextView";
import CartTable from "../components/list/CartTable";
import ButtonSimp from "../components/button";
import BasicInput from "../components/edittext/basicInput/basicInput";
import Toolbar from "../containers/Header/Toolbar/Toolbar";
import Footer from "../containers/Footer/Footer";
import useDynamicTabTitle from "../useDynamicTabTitle";


const CartPage = () => {
  const [cart, setCart] = useState([]);
  const [promocode, setPromocode] = useState("");
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(true);

  const totalQty = cart.reduce((s, it) => s + Number(it.quantity || 0), 0);
  const totalPrice = cart.reduce(
    (s, it) => s + Number(it.price || 0) * Number(it.quantity || 0),
    0
  );
useDynamicTabTitle("Shopping Cart");
  const formatPrice = (n, suffix = "$") =>
    `${Number(n || 0).toLocaleString()}${suffix}`;

  const fetchCart = async () => {
    try {
      const res = await axios.get("/cart");
      setCart(res.data?.items || []);
    } catch (err) {
      console.error("Error fetching cart:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchBanner = async () => {
    try {
      const res = await axios.get("/site-content", {
        params: { type: "campaign", status: "active" },
      });
      setBanner(res.data?.items?.[0]);
    } catch (err) {
      console.error("Error loading banner:", err);
    }
  };

  useEffect(() => {
    fetchCart();
    fetchBanner();
  }, []);

  const handleUpdateQty = async (productId, quantity) => {
    try {
      await axios.put("/cart/update", { productId, quantity });
      fetchCart();
    } catch (err) {
      console.error(err);
    }
  };

  const handleRemove = async (productId) => {
    try {
      await axios.delete("/cart/remove", { data: { productId } });
      fetchCart();
    } catch (err) {
      console.error(err);
    }
  };

  const handleCheckout = async () => {
    try {
      const res = await axios.post("/orders/checkout");
      alert("Order placed!");
    } catch (err) {
      console.error(err);
    }
  };

  if (loading)
    return <p className="text-center mt-5">Loading...</p>;

  if (!cart.length)
    return (
      <>
        {/* {banner && <CampaignBanner image={banner.image} link={banner.link} />} */}
        <Toolbar />
        <div className="container text-center my-5">
          <h4>Your shopping cart is empty.</h4>
          <a href="/products" className="btn btn-link mt-2">
         View products
          </a>
        </div>
        <Footer />
      </>
    );

  return (
    <>
      {/* {banner && <CampaignBanner image={banner.image} link={banner.link} />} */}
      <Toolbar />

      <div className="container my-5">
        <h3 className="fw-bold mb-4">Shopping Cart</h3>

        <div
          className="cart-layout d-grid gap-4"
          style={{
            gridTemplateColumns: "2fr 1fr",
          }}
        >
          {/* 🧩 جدول محصولات */}
          <div className="cart-table bg-white rounded-3 shadow-sm p-0">
            <CartTable
              items={cart}
              onUpdateQty={handleUpdateQty}
              onRemove={handleRemove}
              currency="$"
            />
          </div>

          {/* 🧾 خلاصه سفارش */}
          <div className="order-summary bg-light rounded-3 shadow-sm p-2 m-1 h-fit">
            <TextView size="lg" bold color="dark">
              Order Summary
            </TextView>
            <hr />

            <div className="d-flex justify-content-between mb-2">
              <span>{totalQty} Items</span>
              <span>{formatPrice(totalPrice, "$")}</span>
            </div>

            <div className="d-flex row align-items-center mb-3 gap-2 m-1 m-lg-5 ">
              <BasicInput
                text="Promo Code"
                value={promocode}
                onChange={setPromocode}
                bgcolor="white"
                textcolor="black"
              />
              <ButtonSimp
                color="danger"
                size="sm"
                text="Apply"
                
                clicked={() => alert("Discount code applied")}
              />
            </div>

            <hr />
            <div className="d-flex justify-content-between fw-bold mb-3">
              <span>Total Cost</span>
              <span>{formatPrice(totalPrice, "$")}</span>
            </div>

            <ButtonSimp
              color="primary"
              size="md"
              text="Checkout"
              padding="2"
              clicked={handleCheckout}
            />
          </div>
        </div>
      </div>

      <Footer />

      {/* 🔹 استایل واکنش‌گرا */}
      <style>{`
        @media (max-width: 992px) {
          .cart-layout {
            grid-template-columns: 1fr;
          }
          .order-summary {
            margin-top: 1rem;
          }
        }
      `}</style>
    </>
  );
};

export default CartPage;

